/* The status dot: Fluent's InfoBadge without a number. A flat filled circle
   in the state's colour, and never the only channel — every call site pairs
   it with the word it stands for. */

.lens {
  display: block;
  flex: none;
  border-radius: var(--radius-round);
  background: var(--lamp, var(--ink-faint));
}

.md {
  width: 0.5rem;
  height: 0.5rem;
}

.sm {
  width: 0.375rem;
  height: 0.375rem;
}

.lens[data-tone="ok"] {
  --lamp: var(--ok);
}

.lens[data-tone="warn"] {
  --lamp: var(--warn);
}

.lens[data-tone="danger"] {
  --lamp: var(--danger);
}

/* A categorical colour — a person on a bill, a calendar — from whatever
   `--tone` the row already sets. */
.lens[data-tone="tone"] {
  --lamp: var(--tone, var(--ink-faint));
}

/* Off: the ring of a dot. Still there, visibly unlit. */
.lens[data-tone="off"] {
  background: transparent;
  box-shadow: inset 0 0 0 1px var(--line-control);
}
